const categoryList = [
  { value: 'FIRST', label: '一类'},
  { value: 'SECOND', label: '二类'},
  { value: 'THIRD', label: '三类'},
];

export {
  categoryList,
};
